import { Injectable } from '@angular/core';
import { PreloadingStrategy, Route } from '@angular/router';
import { Observable, of, timer } from 'rxjs';
import { switchMap } from 'rxjs/operators';

/**
 * Estrategia de precarga con retraso de 3 segundos.
 *
 * Evita competir con el render inicial: espera que la app esté
 * visible e interactiva antes de descargar los chunks lazy en background.
 *
 * Rutas marcadas con data: { preload: false } se excluyen completamente.
 */
@Injectable({ providedIn: 'root' })
export class PreloadConRetrasoStrategy implements PreloadingStrategy {
  private readonly RETRASO_MS = 3000;

  preload(route: Route, load: () => Observable<unknown>): Observable<unknown> {
    if (route.data?.['preload'] === false) {
      return of(null);
    }
    return timer(this.RETRASO_MS).pipe(switchMap(() => load()));
  }
}
